if (!customElements.get('related-products-loader')) {
  customElements.define(
    'related-products-loader',
    class RelatedProductsLoader extends HTMLElement {
      connectedCallback() {
        // When recommendations arrive, product-recommendations.js (global.js) replaces the
        // entire innerHTML of the parent <product-recommendations>, which removes this element
        // automatically. If this product simply has no recommendations, nothing replaces it,
        // so fall back to hiding the spinner after a reasonable wait instead of leaving it stuck.
        this.timeout = setTimeout(() => this.remove(), 5000);
      }

      disconnectedCallback() {
        clearTimeout(this.timeout);
      }
    }
  );
}
